import { render, staticRenderFns } from "./AddScopesModal.vue?vue&type=template&id=47e8168c&scoped=true&"
import script from "./AddScopesModal.vue?vue&type=script&lang=js&"
export * from "./AddScopesModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e8168c",
  null
  
)

export default component.exports